/* tslint:disable */
/* eslint-disable */
/**
 * CAST.AI API documentation
 * ### Feature maturity indicators (may appear on resources, operations and request/response fields)  - **(BETA)** - new or experimental features, subject to change  - **(Deprecated)** - outdated or replaced features (a reason and removal date will be provided in the description) 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */

export const CastaiInventoryV1beta1NodeComponentType = {
    TYPE_UNSPECIFIED: 'TYPE_UNSPECIFIED',
    CPU: 'CPU',
    MEMORY: 'MEMORY',
    GPU: 'GPU',
    EXTENDED_MEMORY: 'EXTENDED_MEMORY',
    TPU: 'TPU'
} as const;

export type CastaiInventoryV1beta1NodeComponentType = typeof CastaiInventoryV1beta1NodeComponentType[keyof typeof CastaiInventoryV1beta1NodeComponentType];



